import React from "react";
import Section from "@/components/ui/section";
const reportLinks = [
  {
    label: "Coping With Climate",
    href: "https://www.copingwithclimate.peoplescourageinternational.org",
    color: "#e88857",
  },
  {
    label: "Cities and Heat",
    href: "https://www.hotcities.peoplescourageinternational.org/",
    color: "#1f78b4",
  },
  {
    label: "Behind the Algorithm",
    href: "https://www.behindthealgorithm.peoplescourageinternational.org/",
    color: "#4d8b57",
  },
];

function ArrowIcon() {
  return (
    <svg
      className="w-[30px] h-[30px] sm:w-[34px] sm:h-[34px] shrink-0"
      viewBox="0 0 56 56"
      aria-hidden="true"
    >
      <circle cx="28" cy="28" r="28" fill="currentColor" />
      <path
        d="M19 35 35 20M27 20h8v8"
        fill="none"
        stroke="#fff"
        strokeWidth="3.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function SurveyData() {
  return (
    <Section className="relative">
      {/* Facts + description */}
      <div className="w-full flex lg:flex-row flex-col-reverse lg:gap-20 md:gap-6 gap-3">
        <div className="text-[#373737] text-lg leading-relaxed">
          <div className="[&>p]:mb-[22px]">
            <p>
              <strong>~2 billion people</strong> – nearly{" "}
              <a
                className="text-[#065ad8] underline"
                href="https://www.ilo.org/publications/women-and-men-informal-economy-statistical-update"
                target="_blank"
                rel="noopener noreferrer"
              >
                60% of the global workforce
              </a>{" "}
              – are part of the informal economy.
            </p>
            <p>
              Informal enterprises contribute up to{" "}
              <a
                className="text-[#065ad8] underline"
                href="https://ilostat.ilo.org/topics/informality/"
                target="_blank"
                rel="noopener noreferrer"
              >
                37% of GDP
              </a>{" "}
              in many low-income countries.
            </p>
            <p>
              This makes informal workers a defining, yet often{" "}
              <strong>unseen</strong>, part of the global economy.
            </p>
          </div>

          <p className="mb-6">
            Informal workers navigate insecure livelihoods, irregular hours, and
            low wages, often without access to basic protections. Their work
            directly exposes them to extreme weather events, leaving them
            acutely vulnerable to the escalating impacts of climate shocks. Yet
            they remain largely absent from data, policy, and public
            discourse—their experiences undercounted and their voices unheard.
          </p>

          <p>
            This data hub, based on research studies, is our contribution to
            address these existing gaps. It brings data and evidence on informal
            workers and their climate vulnerability into clear, accessible view,
            so that their lived realities can no longer be overlooked.
          </p>
        </div>
        {/* Report links: stacked & centered on mobile, floated top-right from 480px up */}
        <div className="flex flex-col w-fit gap-2 mb-6" aria-label="Reports">
          {reportLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={link.label}
              style={{ color: link.color }}
              className="flex items-center justify-between gap-2 sm:gap-3 rounded-full bg-white/95 px-2.5 py-[7px] sm:px-3.5 sm:py-2.5 font-bold whitespace-nowrap shadow-[0_2px_12px_rgba(0,0,0,0.16)] text-[1.05rem] sm:text-[1.1rem] leading-none hover:scale-[1.03] transition-transform duration-200"
            >
              {link.label}
              <ArrowIcon />
            </a>
          ))}
        </div>
      </div>
    </Section>
  );
}
